<h2 class="pt-4 pb-2">Tracking</h2>
<app-search-bar></app-search-bar>


<!-- Results -->
<div class="mt-5" *ngIf="trackingResponse?.results?.length">
  <div class="mb-5">
    <app-summary [trackingResponse]="trackingResponse"></app-summary>
  </div>

  <div class="mt-3" *ngFor="let shippingContainer of trackingResponse.results">
    <app-container [shippingContainer]="shippingContainer"></app-container>
  </div>
</div>

<!-- No results found -->
<div class="mt-5" *ngIf="trackingResponse && !trackingResponse.results?.length">
  <div class="h-100 p-5 mt-5 bg-light border rounded-3">
    <h3>Not found</h3>
    <p>Nothing found for search string <span class="search-value">{{searchString}}</span></p>
  </div>
</div>
